import { render, staticRenderFns } from "./PurchaseData.vue?vue&type=template&id=eb5757e2&"
import script from "./PurchaseData.vue?vue&type=script&lang=js&"
export * from "./PurchaseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports